import { TableDateCell, TableTextCell, TableUserCell } from '../../Table'
import { toUserMultiValue } from '../../User'
import { DocFlowTableRowFile } from '../DocFlowTableRowFile'
import { DocFlowUploadingTypeCell } from '../DocFlowUploadingTypeCell'

import { DocFlowUploadingTableCellName } from './DocFlowUploadingTableRow.constants'

export function renderCell({ item, name, onClickEditType, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case DocFlowUploadingTableCellName.Name:
      return <DocFlowTableRowFile {...restProps} item={item} />

    case DocFlowUploadingTableCellName.PagesCount:
      return <TableTextCell {...restProps} value={value} />

    case DocFlowUploadingTableCellName.UploadedBy:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )

    case DocFlowUploadingTableCellName.Uploaded:
      return <TableDateCell {...restProps} value={value} />

    case DocFlowUploadingTableCellName.Type:
      return (
        <DocFlowUploadingTypeCell
          {...restProps}
          value={value}
          onClickEditType={onClickEditType}
        />
      )

    default:
      break
  }
}
